import React from 'react';
import { Avatar, AvatarGroup, Box, Typography } from '@mui/material';
import { AudiencePill, CardActions, FONT, PositionBadge, StatusPill, cardSx } from './contentShared';

const TabsCard = ({ product, onEdit, onDelete, onOpenDetails }) => {
  const name = product?.name || 'Untitled Tab';
  const products = Array.isArray(product?.products) ? product.products : [];
  const images = products.map((p) => p?.image).filter(Boolean);

  return (
    <Box sx={{ ...cardSx, cursor: 'pointer' }} onClick={() => onOpenDetails && onOpenDetails(product)}>
      <Box sx={{ p: 2.5, display: 'flex', flexDirection: 'column', gap: 1.5, flex: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
            <PositionBadge position={product?.position} />
            <Typography sx={{ fontFamily: FONT, fontWeight: 800, fontSize: 15.5, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={name}>{name}</Typography>
          </Box>
          <StatusPill status={product?.status} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <AudiencePill value={product?.showTo} />
          <Typography sx={{ fontFamily: FONT, fontSize: 11.5, color: '#64748b' }}>{products.length} product{products.length === 1 ? '' : 's'}</Typography>
        </Box>
        <Box sx={{ minHeight: 44 }}>
          {images.length > 0 ? (
            <AvatarGroup max={6} sx={{ justifyContent: 'flex-start', '& .MuiAvatar-root': { width: 40, height: 40, fontSize: 11.5, fontWeight: 800, fontFamily: FONT, border: '2px solid #fff' } }}>
              {images.slice(0, 8).map((src, i) => <Avatar key={i} src={src} />)}
            </AvatarGroup>
          ) : (
            <Typography sx={{ fontFamily: FONT, fontSize: 11.5, color: '#94a3b8' }}>No products added yet</Typography>
          )}
        </Box>
        <Box sx={{ mt: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
          <CardActions onView={() => onOpenDetails && onOpenDetails(product)} onEdit={() => onEdit && onEdit(product)} onDelete={() => onDelete && onDelete(product)} />
        </Box>
      </Box>
    </Box>
  );
};

export default TabsCard;
